import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { formatNaira, formatDateDDMMYYYY } from "@/lib/format";
import { toast } from "sonner";
import { CreditCard, CheckCircle2 } from "lucide-react";

const PAYABLE_STATUSES = ["SENT", "VIEWED", "OVERDUE"];

const renderPayAction = (invoice, payingId, onPay) => {
  if (PAYABLE_STATUSES.includes(invoice.status)) {
    return (
      <button onClick={() => onPay(invoice.id)} disabled={payingId === invoice.id}
              className="btn-primary inline-flex items-center gap-2"
              style={{ padding: "6px 12px", fontSize: 12 }} data-testid={`pay-${invoice.id}`}>
        <CreditCard size={12} /> {payingId === invoice.id ? "Paying..." : "Pay now"}
      </button>
    );
  }
  if (invoice.status === "PAID") {
    return (
      <span className="text-success inline-flex items-center gap-1" style={{ fontSize: 12 }}>
        <CheckCircle2 size={12} /> Paid
      </span>
    );
  }
  return null;
};

export const PortalInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [paying, setPaying] = useState(null);

  const load = useCallback(async () => {
    const r = await api.get("/invoices");
    setInvoices(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const pay = async (id) => {
    setPaying(id);
    try {
      // Simulate Paystack popup
      await new Promise(r => setTimeout(r, 900));
      const res = await api.post(`/invoices/${id}/pay`);
      toast.success(`Payment successful · ${res.data.reference}`, { description: formatNaira(res.data.amount) });
      load();
    } catch { toast.error("Payment failed"); }
    finally { setPaying(null); }
  };

  const statusColor = (s) => {
    if (s === "PAID") return "#2D9E5F";
    if (s === "OVERDUE") return "#E63946";
    if (s === "SENT" || s === "VIEWED") return "#C9A84C";
    return "#8CA0B8";
  };

  return (
    <div className="space-y-4">
      <div className="s-card-light" style={{ padding: 0 }}>
        <table className="s-table s-table-light">
          <thead><tr><th>Invoice #</th><th>Total</th><th>Due</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {invoices.map(i => (
              <tr key={i.id} data-testid={`pinv-${i.id}`}>
                <td className="mono">{i.invoice_no}</td>
                <td className="mono">{formatNaira(i.totals?.total || 0)}</td>
                <td className="mono">{formatDateDDMMYYYY(i.due_at)}</td>
                <td>
                  <span style={{ padding: "4px 10px", borderRadius: 9999, fontSize: 12, color: statusColor(i.status),
                                 background: statusColor(i.status) + "20" }}>
                    {i.status}
                  </span>
                </td>
                <td>
                  {renderPayAction(i, paying, pay)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-muted text-center" style={{ fontSize: 12 }}>
        Payments processed by Paystack · Card · Bank transfer · USSD *737#
      </div>
    </div>
  );
};
